import { useSankeyFormContext } from '../../contexts/sankeyFormContext';
import { FormTextInput } from '../SankeyForm';

const DataSourceNotes: React.FC = () => {
  const { isFetching } = useSankeyFormContext();
  return (
    <FormTextInput
      field="data_source_notes"
      label="Data source notes"
      disabled={isFetching}
      size="sm"
      mt={3}
    />
  );
};

export default DataSourceNotes;
